export const extractStartTime = (markName: string): number =>
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	(performance.getEntriesByName(markName, 'mark')[0] || { startTime: 0 }).startTime;
